import { render, staticRenderFns } from "./Sepetim.vue?vue&type=template&id=4b504260&"
import script from "./Sepetim.vue?vue&type=script&lang=js&"
export * from "./Sepetim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports